import { useMutation } from '@apollo/client';
import { DOG_BREED_INTEREST_SUBSCRIPTION } from '@application/api';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { ToggleDogBreedInDogBreedInterestSubscriptionInput } from '@gql/graphql';
import { useCallback } from 'react';

export const TOGGLE_DOG_BREED_IN_DOG_BREED_INTEREST_TO_SUBSCRIPTION = graphql(`
  mutation ToggleDogBreedInterestToSubscription(
    $data: ToggleDogBreedInDogBreedInterestSubscriptionInput!
  ) {
    toggleDogBreedInDogBreedInterestSubscription(data: $data) {
      id
    }
  }
`);

export const useToggleDogBreedInDogBreedInterestSubscription = () => {
  const { language, countryCode } = useRouter();

  const [toggleDogBreedInDogBreedInterestSubscription, { loading }] = useMutation(
    TOGGLE_DOG_BREED_IN_DOG_BREED_INTEREST_TO_SUBSCRIPTION,
    {
      refetchQueries: [DOG_BREED_INTEREST_SUBSCRIPTION],
      awaitRefetchQueries: true,
    },
  );

  const toggleDogBreedInDogBreedInterestSubscriptionFromButton = useCallback(
    async (
      params: Pick<
        ToggleDogBreedInDogBreedInterestSubscriptionInput,
        'dogBreedName' | 'email' | 'hasADog'
      >,
    ) => {
      const { email, dogBreedName, hasADog } = params;
      await toggleDogBreedInDogBreedInterestSubscription({
        variables: {
          data: {
            email,
            language,
            country: countryCode,
            dogBreedName,
            hasADog,
          },
        },
      });
    },
    [countryCode, language, toggleDogBreedInDogBreedInterestSubscription],
  );

  return {
    toggleDogBreedInDogBreedInterestSubscriptionFromButton,
    toggleDogBreedInDogBreedInterestSubscriptionLoading: loading,
  };
};
